module.exports = __webpack_public_path__ + "img/quizmayhem_banner_movies.1023ec0c.jpg";